var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',[_vm._v(_vm._s(_vm.$t("私有属性")))]),_c('el-form-item',{attrs:{"label":_vm.$t('应用于高级查询')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }